const carroucel = require('../../components/carousel/carousel.script');
const rellax = require('../../components/rellax/rellax.script');
const main_banner = require('../../components/main_banner/main_banner.script');
const AOS_animation = require('../../components/AOS-animation/AOS-animation.script');
const FV = require('../../components/form-validation/form-validation.script');
const indicate = require("../../../services/indicate-friend")
const swal = require('sweetalert')

export async function load() {
    const formEl_formONG = document.getElementById('formAjudaOng');
    const formEl_formAmigo = document.getElementById('formAjudaAmigo');
    await startForm(formEl_formONG, 'ong');
    await startForm(formEl_formAmigo, 'friend');
    await FV.addMasksToView(formEl_formONG);
    await FV.addMasksToView(formEl_formAmigo);

    try {
        await AOS_animation.start();
        return true
    } catch (err) {
        console.log('err', err)
        return err
    }
}

function startForm(formEl, type) {
    formEl
        .addEventListener('submit', function (evt) {
            evt.preventDefault()
            FV.clearErrosMessages(formEl)
            sendForm(formEl, type)
        })
}

async function sendForm(formEL, type) {


    if (FV.thisFormIsValid(formEL)) {
        try {
            const formValues = await FV.getFormValues(formEL);

            indicate.sendIndicate(formValues, type);

            swal("Indicação enviada com sucesso", 'Sua indicação foi bem-sucedida. Agradecemos por ajudar o bem a se espalhar', "success");

            formEL.reset();
        } catch (err) {
            swal("Erro ao enviar a indicação", "Tente novamente mais tarde", "error");
        }

    }
}
